import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";
import UserContext from "../../UserContext";
import Avatar from "../../components/Avatar/Avatar";

/*
    NB: A lot of these styles are inherited from index.html
*/
const Header = (props) => {

    const { user, isLoggedIn } = useContext(UserContext);
    const history = useHistory();

    const handleClickSearch = () => {
        history.push('/search');
    };

    return (
        <header>
            <div className="inner">
                <div className="name">
                    <div className="mr-2">{props.hostelTitle}</div>
                    {/*<a href="#" className="d-inline-block">change</a>*/}
                </div>
                <div className="sub-nav">
                    <div className="icons" onClick={handleClickSearch}>
                        {/*<CurrencyIconWhite />*/}
                        <SearchIconWhite />
                    </div>
                    <div className="avatar">
                        <Link to={isLoggedIn() ? '/account' : '/login'} className="no-underline">
                            <Avatar user={user} showFallback={true} shade="light" width="33px" height="33px" />
                        </Link>
                    </div>
                </div>
            </div>
        </header>
    );

};

Header.propTypes = {
    hostelTitle: PropTypes.string.isRequired
};

export default Header;

const CurrencyIconWhite = () => {
    return (
        <svg width="22px" height="22px" viewBox="0 0 22 22">
            <title>Currency Copy</title>
            <defs>
                <filter colorInterpolationFilters="auto" id="currency-filter-1">
                    <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"/>
                </filter>
                <path d="M11,-9.43979344e-07 C15.4298761,-0.00178391794 19.428565,2.65387728 21.1450708,6.73767613 C22.8615766,10.821475 21.9609139,15.5364358 18.86,18.7 C18.6667004,18.8988225 18.3488225,18.9032997 18.15,18.71 C17.9511775,18.5167004 17.9467004,18.1988225 18.14,17.9999991 C21.4730349,14.5996242 21.9462593,9.32077126 19.2711629,5.3817947 C16.5960665,1.44281813 11.514664,-0.0636939617 7.12492953,1.78073229 C2.73519505,3.62515854 0.254747269,8.30891866 1.19583857,12.9764688 C2.13692987,17.6440189 6.2385216,21.0006802 11,20.9999991 C12.4691931,21.0198451 13.9243821,20.7124108 15.26,20.1 C15.3805414,20.0420795 15.5192621,20.0348623 15.6451632,20.0799612 C15.7710643,20.1250601 15.8736514,20.2187159 15.93,20.34 C15.9875466,20.4590803 15.9945125,20.5963664 15.9493149,20.72066 C15.9041172,20.8449536 15.8105946,20.9456983 15.69,20.9999991 C14.2210338,21.6796088 12.6184175,22.021318 11,21.9999991 C4.92486773,21.9999991 -4.58334739e-08,17.0751323 -4.58334739e-08,10.9999991 C-4.58334739e-08,4.92486773 4.92486773,-9.43979344e-07 11,-9.43979344e-07 Z M10.8079467,5.9989281 C10.9276505,5.92063553 11.0823495,5.92063553 11.2020533,5.9989281 C11.3217571,6.07722066 11.3837561,6.21895258 11.36,6.35999998 L11.36,6.35999998 L11.36,6.99999998 C12.4230581,7.00372815 13.3684752,7.67673699 13.72,8.67999999 C13.7296595,8.7663975 13.7296595,8.85360248 13.72,8.93999999 C13.7229129,9.05667001 13.6771496,9.16929141 13.5936827,9.25086134 C13.5102158,9.33243126 13.3965722,9.3755938 13.28,9.36999999 C13.0633992,9.36863615 12.8785033,9.21315546 12.84,8.99999999 C12.645424,8.33511859 12.0518387,7.86586531 11.36,7.82999999 L11.36,7.82999999 L11.36,10.62 L11.55,10.62 C13.09,10.92 13.85,11.62 13.85,12.78 C13.7748319,14.080336 12.6604076,15.0739191 11.36,15 L11.36,15 L11.36,15.64 C11.3659056,15.7371684 11.3298777,15.8322074 11.2610425,15.9010426 C11.1922074,15.9698777 11.0971683,16.0059057 11,16 C10.8195227,16.0060066 10.6658334,15.8698818 10.65,15.69 L10.65,15.69 L10.65,15 C9.48249265,15.0190977 8.45000443,14.2457599 8.13999999,13.12 C8.13509752,13.0334027 8.13509752,12.9465973 8.13999999,12.86 C8.13147614,12.7444029 8.17228043,12.6305992 8.25231411,12.5467544 C8.33234779,12.4629096 8.44413163,12.4168591 8.55999999,12.42 C8.78138047,12.4179333 8.96982008,12.5806766 8.99999999,12.8 C9.17516448,13.5737304 9.85679137,14.1272941 10.65,14.14 L10.65,14.14 L10.65,11.24 L10.55,11.24 C9.07999999,10.89 8.32999999,10.23 8.32999999,9.14999999 C8.40960308,7.93091877 9.42839412,6.98678052 10.65,6.99999998 L10.65,6.99999998 L10.65,6.35999998 C10.6262439,6.21895258 10.6882429,6.07722066 10.8079467,5.9989281 Z M11.36,11.42 L11.36,14.14 C12.38,14.05 12.96,13.43 12.96,12.78 C12.96,12.13 12.56,11.73 11.56,11.47 L11.56,11.47 L11.36,11.42 Z M10.65,7.82999999 C9.79999999,7.93999999 9.20999999,8.46999999 9.20999999,9.08999999 C9.20999999,9.70999999 9.65999999,10.09 10.59,10.34 L10.59,10.34 L10.65,10.36 Z" id="currency-path-2"/>
                <filter colorInterpolationFilters="auto" id="currency-filter-4">
                    <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 0.431373 0 0 0 0 0.458824 0 0 0 1.000000 0"/>
                </filter>
            </defs>
            <g id="currency-filter-ICON-SET" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Currency-Copy" transform="translate(-216.000000, -61.000000)" filter="url(#currency-filter-1)">
                    <g transform="translate(216.000000, 61.000000)">
                        <mask id="currency-mask-3" fill="white">
                            <use xlinkHref="#currency-path-2"/>
                        </mask>
                        <g id="Combined-Shape" fillRule="nonzero"/>
                        <g id="Group" mask="url(#currency-mask-3)">
                            <g transform="translate(-1.000000, -1.000000)" id="🎨-color" filter="url(#currency-filter-4)">
                                <g>
                                    <rect id="Primary" fill="#000000" x="0" y="0" width="24" height="24"/>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

const SearchIconWhite = () => {
    return (
        <svg width="22px" height="22px">
            <defs>
                <filter colorInterpolationFilters="auto" id="search-header-filter-1">
                    <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"/>
                </filter>
                <path d="M21.48,22.000035 C21.3473962,22.0016166 21.2202804,21.9471384 21.13,21.85 L16.35,17.09 C16.2523416,16.9959244 16.1980339,16.8655858 16.2,16.73 C16.1983835,16.5973962 16.2528617,16.4702804 16.35,16.38 C19.6937708,13.0491993 19.8965632,7.70113194 16.8146315,4.12667621 C13.7326998,0.552220472 8.41302719,-0.0343220221 4.62636476,2.78280848 C0.839702333,5.59993899 -0.127558143,10.8637168 2.41020797,14.8430106 C4.94797408,18.8223045 10.1286457,20.1652827 14.28,17.92 C14.5235265,17.792525 14.8242668,17.880978 14.96,18.12 C15.0232181,18.2378494 15.0365906,18.3761126 14.997129,18.5038928 C14.9576675,18.6316731 14.8686613,18.7383193 14.75,18.8 C10.7905498,20.9372378 5.8912855,20.166926 2.77874033,16.9177579 C-0.333804838,13.6685898 -0.893072021,8.74077172 1.41218155,4.87672763 C3.71743513,1.01268354 8.31947073,-0.835948258 12.6571684,0.359630817 C16.9948662,1.55520989 19.9999361,5.50055217 20,10 C20.0009782,12.4887091 19.0739232,14.8883553 17.4,16.73 L21.83,21.15 C21.9700599,21.2928502 22.0114878,21.5054357 21.935316,21.6904243 C21.8591442,21.8754129 21.6800376,21.99719 21.48,22.000035 Z" id="search-header-path-2"/>
                <filter colorInterpolationFilters="auto" id="search-header-filter-4">
                    <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 0.431373 0 0 0 0 0.458824 0 0 0 1.000000 0"/>
                </filter>
            </defs>
            <g id="search-header-filter-ICON-SET" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Search-Copy" transform="translate(-243.000000, -61.000000)" filter="url(#search-header-filter-1)">
                    <g transform="translate(243.000000, 61.000000)">
                        <mask id="search-header-mask-3" fill="white">
                            <use xlinkHref="#search-header-path-2"/>
                        </mask>
                        <g id="35" fillRule="nonzero"/>
                        <g filter="url(#search-header-filter-4)" id="🎨-color">
                            <g mask="url(#search-header-mask-3)">
                                <g transform="translate(-1.000000, -1.000000)" fill="#000000" id="Primary">
                                    <rect x="0" y="0" width="24" height="24"/>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};